import React from 'react';
import Link, { Props } from '.';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

export default function SchoolyearLink(
  props: Props & { withSchoolContext?: boolean; readonly?: boolean },
) {
  const { to, withSchoolContext = true, readonly, ...rest } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  if (readonly) {
    return <div className={rest.className}>{rest.children}</div>;
  }

  return (
    <Link
      to={
        withSchoolContext
          ? `/annee-scolaire/${schoolyear.id}/ecole/${school.id}/${to}`
          : to
      }
      {...rest}
    />
  );
}
